import mixpanel from 'mixpanel-browser';

const isProd = window.location.origin.indexOf("grafonote.com") > -1;

mixpanel.init(!isProd ? "b2bc2dda790bfd97dc215688cd17bbc1" : "e39385b82e3637082f3df5ee2b0148da");

export default mixpanel;